export default "__VITE_ASSET__Xbp1x2mM__"